import { Link } from 'react-router-dom';

const FOOTER_SOCIAL_LINKS = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/vettail.in',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2Zm0 1.75a4 4 0 0 0-4 4v8.5a4 4 0 0 0 4 4h8.5a4 4 0 0 0 4-4v-8.5a4 4 0 0 0-4-4h-8.5Zm8.9 1.8a1.1 1.1 0 1 1 0 2.2 1.1 1.1 0 0 1 0-2.2ZM12 6.85a5.15 5.15 0 1 1 0 10.3 5.15 5.15 0 0 1 0-10.3Zm0 1.75a3.4 3.4 0 1 0 0 6.8 3.4 3.4 0 0 0 0-6.8Z" />
      </svg>
    )
  },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            <span>Vettail</span>
          </Link>
          <p>vet-trusted pet essentials.<br />toys, grooming, and recovery &amp; health care picks.</p>
          <nav className="footer-social" aria-label="Social media">
            {FOOTER_SOCIAL_LINKS.map(({ label, href, icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label={label}
                title={label}
              >
                {icon}
              </a>
            ))}
          </nav>
        </div>

        <div className="footer-col">
          <h4></h4>
          <ul>
            <li><Link to="/shop">shop all</Link></li>
            <li><Link to="/shop/toys">toys</Link></li>
            <li><Link to="/shop/recovery-health">recovery & health</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4></h4>
          <ul>
            <li><Link to="/about">about us / contact us</Link></li>
            <li><Link to="/shipping">shipping & returns</Link></li>
            <li><Link to="/faq">faqs</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <span className="footer-bottom-copy">&copy; {new Date().getFullYear()} Vettail. all rights reserved.</span>
        <div className="footer-bottom-links" aria-label="Legal links">
          <Link to="/privacy-policy">privacy policy</Link>
          <Link to="/disclaimer">disclaimer</Link>
        </div>
        <span className="footer-bottom-powered">
          powered by <a href="https://www.thewhizkind.com" target="_blank" rel="noopener noreferrer">thewhizkind</a>
        </span>
      </div>
    </footer>
  );
}
